import { 
    KANBAN_START_LOADING, 
    KANBAN_END_LOADING, 
    SET_KANBAN_FILTER,
    KANBAN_DRAFT_LOADED, 
    KANBAN_NEW_LOADED,
    KANBAN_INPROGRESS_LOADED,
    KANBAN_SALES_ACTION_LOADED,
    KANBAN_PD_REVIEW_LOADED,
    KANBAN_TECHNICAL_REVIEW_LOADED,
    KANBAN_TECHNICAL_SUPPORT_LOADED,
    KANBAN_PENDING_FOR_SAMPLING_LOADED,
    KANBAN_SAMPLING_IN_PROCESS_LOADED,
    KANBAN_SCHEDULED_LOADED,
    KANBAN_WAITING_CORRECTIVE_ACTION_LOADED,
    KANBAN_DATA_REVIEW_LOADED,
    KANBAN_PHASE_1_EVALUATION_LOADED,
    KANBAN_PENDING_FOR_INSPECTION_LOADED,
    KANBAN_INSPECTION_IN_PROCESS_LOADED,
    KANBAN_NON_CONFORMITY_LOADED,
    KANBAN_PHASE_2_EVALUATION_LOADED,
    KANBAN_FINAL_DECISION_LOADED,
    KANBAN_READY_TO_ISSUE_LOADED,
    KANBAN_COMPLETED_LOADED,
    KANBAN_CLOSED_LOADED,
    KANBAN_CANCELLED_LOADED,
    KANBAN_STOPPED_LOADED,
    KANBAN_ABORTED_LOADED,
    KANBAN_GROUP_LOADED,
    KANBAN_GROUP_USER_LOADED,
    KANBAN_PD_GROUP_LOADED,
    KANBAN_PD_GROUP_USER_LOADED,
    KANBAN_INSPECTION_COORDINATOR_LOADED,
    KANBAN_SAMPLER_LOADED,
    KANBAN_USER_SEARCH_LOADED
} from "../constants/KanbanConstants";

const initialState = {
    loading: false,
    filter: {
        search: "",
        serviceId: 0,
        region: "",
        mineOnly: true,
        dateType: "Added",
        dateValue: []
    },
    draftList: [],
    newList: [],
    inProgressList: [],
    salesActionList: [],
    pdReviewList: [],
    technicalReviewList: [],
    technicalSupportList: [],
    pendingForSamplingList: [],
    samplingInProcessList: [],
    scheduledList: [],
    waitingCorrectiveActionList: [],
    dataReviewList: [],
    phase1EvaluationList: [],
    pendingForInspectionList: [],
    inspectionInProcessList: [],
    nonConformityList: [],
    phase2EvaluationList: [],
    finalDecisionList: [],
    readyToIssueList: [],
    completedList: [],
    closedList: [],
    cancelledList: [],
    stoppedList: [],
    abortedList: [],
    groupList: [],
    groupUserList: [],
    pdGroupList: [],
    pdGroupUserList: [],
    inspectionCoordinatorList: [],
    samplerList: [],
    searchList: []
};

const KanbanReducer = (state = initialState, action) => {
    switch(action.type) {
        case KANBAN_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case KANBAN_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case SET_KANBAN_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        case KANBAN_DRAFT_LOADED:
            return {
                ...state,
                draftList: action.payload
            };
        case KANBAN_NEW_LOADED:
            return {
                ...state,
                newList: action.payload
            };
        case KANBAN_INPROGRESS_LOADED:
            return {
                ...state,
                inProgressList: action.payload
            };
        case KANBAN_SALES_ACTION_LOADED:
            return {
                ...state,
                salesActionList: action.payload
            };
        case KANBAN_PD_REVIEW_LOADED:
            return {
                ...state,
                pdReviewList: action.payload
            };
        case KANBAN_TECHNICAL_REVIEW_LOADED:
            return {
                ...state,
                technicalReviewList: action.payload
            };
        case KANBAN_TECHNICAL_SUPPORT_LOADED:
            return {
                ...state,
                technicalSupportList: action.payload
            };
        case KANBAN_PENDING_FOR_SAMPLING_LOADED:
            return {
                ...state,
                pendingForSamplingList: action.payload
            };
        case KANBAN_SAMPLING_IN_PROCESS_LOADED:
            return {
                ...state,
                samplingInProcessList: action.payload
            };
        case KANBAN_SCHEDULED_LOADED:
            return {
                ...state,
                scheduledList: action.payload
            };
        case KANBAN_WAITING_CORRECTIVE_ACTION_LOADED:
            return {
                ...state,
                waitingCorrectiveActionList: action.payload
            };
        case KANBAN_DATA_REVIEW_LOADED:
            return {
                ...state,
                dataReviewList: action.payload
            };
        case KANBAN_PHASE_1_EVALUATION_LOADED:
            return {
                ...state,
                phase1EvaluationList: action.payload
            };
        case KANBAN_PENDING_FOR_INSPECTION_LOADED:
            return {
                ...state,
                pendingForInspectionList: action.payload
            };
        case KANBAN_INSPECTION_IN_PROCESS_LOADED:
            return {
                ...state,
                inspectionInProcessList: action.payload
            };
        case KANBAN_NON_CONFORMITY_LOADED:
            return {
                ...state,
                nonConformityList: action.payload
            };
        case KANBAN_PHASE_2_EVALUATION_LOADED:
            return {
                ...state,
                phase2EvaluationList: action.payload
            };
        case KANBAN_FINAL_DECISION_LOADED:
            return {
                ...state,
                finalDecisionList: action.payload
            };
        case KANBAN_READY_TO_ISSUE_LOADED:
            return {
                ...state,
                readyToIssueList: action.payload
            };
        case KANBAN_COMPLETED_LOADED:
            return {
                ...state,
                completedList: action.payload
            };
        case KANBAN_CLOSED_LOADED:
            return {
                ...state,
                closedList: action.payload
            };
        case KANBAN_CANCELLED_LOADED:
            return {
                ...state,
                cancelledList: action.payload
            };
        case KANBAN_STOPPED_LOADED:
            return {
                ...state,
                stoppedList: action.payload
            };
        case KANBAN_ABORTED_LOADED:
            return {
                ...state,
                abortedList: action.payload
            };
        case KANBAN_GROUP_LOADED:
            return {
                ...state,
                groupList: action.payload
            };
        case KANBAN_GROUP_USER_LOADED:
            return {
                ...state,
                groupUserList: action.payload
            };
        case KANBAN_PD_GROUP_LOADED:
            return {
                ...state,
                pdGroupList: action.payload
            };
        case KANBAN_PD_GROUP_USER_LOADED:
            return {
                ...state,
                pdGroupUserList: action.payload
            };
        case KANBAN_INSPECTION_COORDINATOR_LOADED:
            return {
                ...state,
                inspectionCoordinatorList: action.payload
            };
        case KANBAN_SAMPLER_LOADED:
            return {
                ...state,
                samplerList: action.payload
            };
        case KANBAN_USER_SEARCH_LOADED:
            return {
                ...state,
                searchList: action.payload
            };
        default:
            return state;
    }
}

export default KanbanReducer;